export enum ResourceType {
  acmCertificate = 'acmCertificate',
  apiGatewayAccount = 'apiGatewayAccount',
  apiGatewayApiKey = 'apiGatewayApiKey',
  apiGatewayBasePathMapping = 'apiGatewayBasePathMapping',
  apiGatewayRestApi = 'apiGatewayRestApi',
  apiGatewayStage = 'apiGatewayStage',
  apiGatewayUsagePlan = 'apiGatewayUsagePlan',
  apiGatewayUsagePlanKey = 'apiGatewayUsagePlanKey',
  apiGatewayV2Api = 'apiGatewayV2Api',
  apiGatewayV2ApiMapping = 'apiGatewayV2ApiMapping',
  apiGatewayV2Authorizer = 'apiGatewayV2Authorizer',
  apiGatewayV2DomainName = 'apiGatewayV2DomainName',
  apiGatewayV2Integration = 'apiGatewayV2Integration',
  apiGatewayV2Route = 'apiGatewayV2Route',
  apiGatewayV2Stage = 'apiGatewayV2Stage',
  apiGatewayV2VpcLink = 'apiGatewayV2VpcLink',
  appConfigApplication = 'appConfigApplication',
  appConfigConfigurationProfile = 'appConfigConfigurationProfile',
  appConfigDeployment = 'appConfigDeployment',
  appConfigEnvironment = 'appConfigEnvironment',
  appConfigHostedConfigurationVersion = 'appConfigHostedConfigurationVersion',
  applicationAutoScalingScalableTarget = 'applicationAutoScalingScalableTarget',
  applicationAutoScalingScalingPolicy = 'applicationAutoScalingScalingPolicy',
  applicationAutoScalingScheduledAction = 'applicationAutoScalingScheduledAction',
  autoScalingGroup = 'autoScalingGroup',
  autoScalingLaunchConfiguration = 'autoScalingLaunchConfiguration',
  autoScalingPolicy = 'autoScalingPolicy',
  cloudWatchAlarm = 'cloudWatchAlarm',
  cognitoIdpIdentityProvider = 'cognitoIdpIdentityProvider',
  cognitoIdpUserPool = 'cognitoIdpUserPool',
  cognitoIdpUserPoolClient = 'cognitoIdpUserPoolClient',
  dynamoDbTable = 'dynamoDbTable',
  ec2Address = 'ec2Address',
  ec2DhcpOptions = 'ec2DhcpOptions',
  ec2EbsVolume = 'ec2EbsVolume',
  ec2EgressOnlyInternetGateway = 'ec2EgressOnlyInternetGateway',
  ec2Image = 'ec2Image',
  ec2Instance = 'ec2Instance',
  ec2InternetGateway = 'ec2InternetGateway',
  ec2LaunchTemplate = 'ec2LaunchTemplate',
  ec2LaunchTemplateVersion = 'ec2LaunchTemplateVersion',
  ec2ManagedPrefixList = 'ec2ManagedPrefixList',
  ec2NatGateway = 'ec2NatGateway',
  ec2NetworkAcl = 'ec2NetworkAcl',
  ec2RouteTable = 'ec2RouteTable',
  ec2SecurityGroup = 'ec2SecurityGroup',
  ec2Subnet = 'ec2Subnet',
  ec2TransitGateway = 'ec2TransitGateway',
  ec2TransitGatewayAttachment = 'ec2TransitGatewayAttachment',
  ec2TransitGatewayRouteTable = 'ec2TransitGatewayRouteTable',
  ec2Vpc = 'ec2Vpc',
  ec2VpcEndpoint = 'ec2VpcEndpoint',
  ec2VpcPeeringConnection = 'ec2VpcPeeringConnection',
  ecrPullThroughCacheRule = 'ecrPullThroughCacheRule',
  ecrRepository = 'ecrRepository',
  ecsCapacityProvider = 'ecsCapacityProvider',
  ecsCluster = 'ecsCluster',
  ecsService = 'ecsService',
  ecsTaskDefinition = 'ecsTaskDefinition',
  ecsTaskSet = 'ecsTaskSet',
  efsAccessPoint = 'efsAccessPoint',
  efsFileSystem = 'efsFileSystem',
  eksAddon = 'eksAddon',
  eksCluster = 'eksCluster',
  eksFargateProfile = 'eksFargateProfile',
  eksNodegroup = 'eksNodegroup',
  elastiCacheCacheCluster = 'elastiCacheCacheCluster',
  elastiCacheCacheParameterGroup = 'elastiCacheCacheParameterGroup',
  elastiCacheCacheSubnetGroup = 'elastiCacheCacheSubnetGroup',
  elastiCacheReplicationGroup = 'elastiCacheReplicationGroup',
  elastiCacheUser = 'elastiCacheUser',
  elastiCacheUserGroup = 'elastiCacheUserGroup',
  elasticBeanstalkApplication = 'elasticBeanstalkApplication',
  elasticBeanstalkApplicationVersion = 'elasticBeanstalkApplicationVersion',
  elasticBeanstalkConfigurationTemplate = 'elasticBeanstalkConfigurationTemplate',
  elasticBeanstalkEnvironment = 'elasticBeanstalkEnvironment',
  elasticBeanstalkPlatformVersion = 'elasticBeanstalkPlatformVersion',
  elbClassicLoadBalancer = 'elbClassicLoadBalancer',
  elbLoadBalancer = 'elbLoadBalancer',
  elbTargetGroup = 'elbTargetGroup',
  eventBridgeArchive = 'eventBridgeArchive',
  eventBridgeEventBus = 'eventBridgeEventBus',
  eventBridgeRule = 'eventBridgeRule',
  firehoseDeliveryStream = 'firehoseDeliveryStream',
  fsxFileSystem = 'fsxFileSystem',
  fsxStorageVirtualMachine = 'fsxStorageVirtualMachine',
  fsxVolume = 'fsxVolume',
  glueJob = 'glueJob',
  glueTrigger = 'glueTrigger',
  iamInstanceProfile = 'iamInstanceProfile',
  iamManagedPolicy = 'iamManagedPolicy',
  iamOidcProvider = 'iamOidcProvider',
  iamRole = 'iamRole',
  iamRoot = 'iamRoot',
  k8sResource = 'k8sResource',
  kmsAlias = 'kmsAlias',
  kmsKey = 'kmsKey',
  kafkaConfigurationRevision = 'kafkaConfigurationRevision',
  kafkaConfiguration = 'kafkaConfiguration',
  kafkaCluster = 'kafkaCluster',
  lambdaFunction = 'lambdaFunction',
  lambdaFunctionAlias = 'lambdaFunctionAlias',
  lambdaFunctionVersion = 'lambdaFunctionVersion',
  lambdaLayerVersion = 'lambdaLayerVersion',
  mqBroker = 'mqBroker',
  mqConfigurationRevision = 'mqConfigurationRevision',
  openSearchDomain = 'openSearchDomain',
  openSearchServerlessCollection = 'openSearchServerlessCollection',
  openSearchServerlessCollectionGroup = 'openSearchServerlessCollectionGroup',
  openSearchServerlessDataAccessPolicy = 'openSearchServerlessDataAccessPolicy',
  openSearchServerlessLifecyclePolicy = 'openSearchServerlessLifecyclePolicy',
  openSearchServerlessSecurityPolicy = 'openSearchServerlessSecurityPolicy',
  openSearchServerlessVpcEndpoint = 'openSearchServerlessVpcEndpoint',
  organization = 'organization',
  osisPipeline = 'osisPipeline',
  ramResourceShare = 'ramResourceShare',
  rdsDbCluster = 'rdsDbCluster',
  rdsDbClusterParameterGroup = 'rdsDbClusterParameterGroup',
  rdsDbInstance = 'rdsDbInstance',
  rdsDbParameterGroup = 'rdsDbParameterGroup',
  rdsDbProxy = 'rdsDbProxy',
  rdsDbProxyEndpoint = 'rdsDbProxyEndpoint',
  rdsDbProxyTargetGroup = 'rdsDbProxyTargetGroup',
  rdsDbSubnetGroup = 'rdsDbSubnetGroup',
  rdsOptionGroup = 'rdsOptionGroup',
  redshiftCluster = 'redshiftCluster',
  redshiftClusterParameterGroup = 'redshiftClusterParameterGroup',
  redshiftClusterSubnetGroup = 'redshiftClusterSubnetGroup',
  redshiftServerlessNamespace = 'redshiftServerlessNamespace',
  redshiftServerlessWorkgroup = 'redshiftServerlessWorkgroup',
  networkFirewallFirewall = 'networkFirewallFirewall',
  networkFirewallPolicy = 'networkFirewallPolicy',
  networkFirewallRuleGroup = 'networkFirewallRuleGroup',
  networkFirewallTlsInspectionConfiguration = 'networkFirewallTlsInspectionConfiguration',
  networkFirewallVpcEndpointAssociation = 'networkFirewallVpcEndpointAssociation',
  dmsCertificate = 'dmsCertificate',
  dmsEndpoint = 'dmsEndpoint',
  dmsReplicationInstance = 'dmsReplicationInstance',
  dmsReplicationSubnetGroup = 'dmsReplicationSubnetGroup',
  dmsReplicationTask = 'dmsReplicationTask',
  resourceGroupsGroup = 'resourceGroupsGroup',
  route53PrivateHostedZone = 'route53PrivateHostedZone',
  route53ProfilesProfile = 'route53ProfilesProfile',
  route53ResolverConfig = 'route53ResolverConfig',
  route53ResolverEndpoint = 'route53ResolverEndpoint',
  route53ResolverFirewallDomainList = 'route53ResolverFirewallDomainList',
  route53ResolverFirewallRuleGroup = 'route53ResolverFirewallRuleGroup',
  route53ResolverRule = 'route53ResolverRule',
  s3Bucket = 's3Bucket',
  schedulerSchedule = 'schedulerSchedule',
  schedulerScheduleGroup = 'schedulerScheduleGroup',
  secretsManagerSecret = 'secretsManagerSecret',
  serviceDiscoveryNamespace = 'serviceDiscoveryNamespace',
  serviceDiscoveryService = 'serviceDiscoveryService',
  sfnStateMachine = 'sfnStateMachine',
  sfnStateMachineVersion = 'sfnStateMachineVersion',
  sfnStateMachineAlias = 'sfnStateMachineAlias',
  snsTopic = 'snsTopic',
  spotElastigroup = 'spotElastigroup',
  sqsQueue = 'sqsQueue',
  ssmParameter = 'ssmParameter',
  transferHostKey = 'transferHostKey',
  transferServer = 'transferServer',
  transferUser = 'transferUser',
  transferWorkflow = 'transferWorkflow',
  wafV2IpSet = 'wafV2IpSet',
  wafV2RegexPatternSet = 'wafV2RegexPatternSet',
  wafV2RuleGroup = 'wafV2RuleGroup',
  wafV2WebAcl = 'wafV2WebAcl',
  bedrockAgentcoreWorkloadIdentity = 'bedrockAgentcoreWorkloadIdentity',
  bedrockAgentcoreMemory = 'bedrockAgentcoreMemory',
  bedrockAgentcoreApiKeyCredentialProvider = 'bedrockAgentcoreApiKeyCredentialProvider',
  bedrockAgentcoreOAuth2CredentialProvider = 'bedrockAgentcoreOAuth2CredentialProvider',
  bedrockAgentcoreRuntime = 'bedrockAgentcoreRuntime',
  bedrockAgentcoreRuntimeEndpoint = 'bedrockAgentcoreRuntimeEndpoint',
  bedrockAgentcoreGateway = 'bedrockAgentcoreGateway',
  bedrockAgentcoreGatewayTarget = 'bedrockAgentcoreGatewayTarget',
  bedrockAgentcorePolicy = 'bedrockAgentcorePolicy',
  bedrockAgentcorePolicyEngine = 'bedrockAgentcorePolicyEngine',
  bedrockAgentcoreBrowser = 'bedrockAgentcoreBrowser',
  bedrockAgentcoreCodeInterpreter = 'bedrockAgentcoreCodeInterpreter',
  bedrockAgentcoreEvaluator = 'bedrockAgentcoreEvaluator',
  bedrockAgentcoreOnlineEvaluationConfig = 'bedrockAgentcoreOnlineEvaluationConfig',
  bedrockGuardrail = 'bedrockGuardrail',
  bedrockKnowledgeBase = 'bedrockKnowledgeBase',
  bedrockKnowledgeBaseDataSource = 'bedrockKnowledgeBaseDataSource',

  azureAksCluster = 'Microsoft.ContainerService/managedClusters',
  azureAksNodePool = 'Microsoft.ContainerService/agentPools',
  azureApplicationGateway = 'Microsoft.Network/applicationGateways',
  azureApplicationSecurityGroup = 'Microsoft.Network/applicationSecurityGroups',
  azureAppServiceEnvironment = 'Microsoft.Web/hostingEnvironments',
  azureAppServicePlan = 'Microsoft.Web/serverfarms',
  azureBastionHost = 'Microsoft.Network/bastionHosts',
  azureBlobContainer = 'Microsoft.Storage/storageAccounts/blobServices/containers',
  azureContainerApp = 'Microsoft.App/containerApps',
  azureContainerAppAuthConfig = 'Microsoft.App/containerApps/authConfigs',
  azureContainerAppJob = 'Microsoft.App/jobs',
  azureContainerAppManagedEnvironment = 'Microsoft.App/managedEnvironments',
  azureContainerAppManagedEnvironmentCertificate = 'Microsoft.App/managedEnvironments/certificates',
  azureContainerAppManagedEnvironmentManagedCertificate = 'Microsoft.App/managedEnvironments/managedCertificates',
  azureContainerGroup = 'Microsoft.ContainerInstance/containerGroups',
  azureContainerRegistry = 'Microsoft.ContainerRegistry/registries',
  azureContainerRepository = 'Microsoft.ContainerRegistry/registries/repositories',
  azureDisk = 'Microsoft.Compute/disks',
  azureDiskEncryptionSet = 'Microsoft.Compute/diskEncryptionSets',
  azureFederatedIdentityCredential = 'Microsoft.ManagedIdentity/userAssignedIdentities/federatedIdentityCredentials',
  azureImage = 'Microsoft.Compute/images',
  azureKeyVault = 'Microsoft.KeyVault/vaults',
  azureKeyVaultCertificate = 'Microsoft.KeyVault/vaults/certificates',
  azureKeyVaultKey = 'Microsoft.KeyVault/vaults/keys',
  azureKeyVaultSecret = 'Microsoft.KeyVault/vaults/secrets',
  azureLoadBalancer = 'Microsoft.Network/loadBalancers',
  azureLogAnalyticsWorkspace = 'Microsoft.OperationalInsights/workspaces',
  azureManagedIdentity = 'Microsoft.ManagedIdentity/userAssignedIdentities',
  azureNatGateway = 'Microsoft.Network/natGateways',
  azureNetAppAccount = 'Microsoft.NetApp/netAppAccounts',
  azureNetAppCapacityPool = 'Microsoft.NetApp/netAppAccounts/capacityPools',
  azureNetAppVolume = 'Microsoft.NetApp/netAppAccounts/capacityPools/volumes',
  azureNetworkInterface = 'Microsoft.Network/networkInterfaces',
  azureNetworkSecurityGroup = 'Microsoft.Network/networkSecurityGroups',
  azurePrivateEndpoint = 'Microsoft.Network/privateEndpoints',
  azurePrivateDnsZoneGroups = 'Microsoft.Network/privateEndpoints/privateDnsZoneGroups',
  azurePrivateDnsZone = 'Microsoft.Network/privateDnsZones',
  azurePrivateDnsZoneVirtualNetworkLink = 'Microsoft.Network/privateDnsZones/virtualNetworkLinks',
  azurePrivateDnsZoneRecordSet = 'Microsoft.Network/privateDnsZones/recordSets',
  azurePublicIp = 'Microsoft.Network/publicIPAddresses',
  azureQueue = 'Microsoft.Storage/storageAccounts/queueServices/queues',
  azureResourceGroup = 'Microsoft.Resources/resourceGroups',
  azureResourceProvider = 'Microsoft.Resources/providers',
  azureRoleAssignment = 'Microsoft.Authorization/roleAssignments',
  azureRoleDefinition = 'Microsoft.Authorization/roleDefinitions',
  azureRouteTable = 'Microsoft.Network/routeTables',
  azureStorageAccount = 'Microsoft.Storage/storageAccounts',
  azureSubnet = 'Microsoft.Network/virtualNetworks/subnets',
  azureSubscription = 'Microsoft.Resources/subscriptions',
  azurePostgresFlexibleServer = 'Microsoft.DBforPostgreSQL/flexibleServers',
  azurePostgresFlexibleServerAdministrator = 'Microsoft.DBforPostgreSQL/flexibleServers/administrators',
  azurePostgresFlexibleServerConfiguration = 'Microsoft.DBforPostgreSQL/flexibleServers/configurations',
  azurePostgresFlexibleServerDatabase = 'Microsoft.DBforPostgreSQL/flexibleServers/databases',
  azurePostgresFlexibleServerFirewallRule = 'Microsoft.DBforPostgreSQL/flexibleServers/firewallRules',
  azureSqlDatabase = 'Microsoft.Sql/servers/databases',
  azureSqlServer = 'Microsoft.Sql/servers',
  azureSqlServerConnectionPolicies = 'Microsoft.Sql/servers/connectionPolicies',
  azureSqlServerDnsAliases = 'Microsoft.Sql/servers/dnsAliases',
  azureSqlServerFirewallRule = 'Microsoft.Sql/servers/firewallRules',
  azureSqlServerOutboundFirewallRule = 'Microsoft.Sql/servers/outboundFirewallRules',
  azureSqlServerVirtualNetworkRule = 'Microsoft.Sql/servers/virtualNetworkRules',
  azureSqlVirtualMachine = 'Microsoft.SqlVirtualMachine/sqlVirtualMachines',
  azureVirtualMachine = 'Microsoft.Compute/virtualMachines',
  azureVirtualMachineScaleSet = 'Microsoft.Compute/virtualMachineScaleSets',
  azureVirtualNetwork = 'Microsoft.Network/virtualNetworks',
  azureVirtualNetworkPeering = 'Microsoft.Network/virtualNetworks/virtualNetworkPeerings',
  azureWebApp = 'Microsoft.Web/sites',
  azureWebAppCertificate = 'Microsoft.Web/certificates',
  azureWebAppHostNameBinding = 'Microsoft.Web/sites/hostNameBindings',
}

export function resourceTypeFromValue(value: string): ResourceType | undefined {
  const key = Object.keys(ResourceType).find((key) => ResourceType[key] === value)
  return key ? ResourceType[key as keyof typeof ResourceType] : undefined
}

export enum ResourceVariant {
  docDbCluster = 'docDbCluster',
  docDbInstance = 'docDbInstance',
  k8sNamespace = 'Namespace',
  k8sDeployment = 'Deployment',
  k8sStatefulSet = 'StatefulSet',
  k8sDaemonSet = 'DaemonSet',
  k8sRollout = 'Rollout',
  k8sJob = 'Job',
  k8sCronJob = 'CronJob',
  k8sConfigMap = 'ConfigMap',
  k8sSecret = 'Secret',
  k8sIngress = 'Ingress',
  k8sService = 'Service',
  k8sServiceAccount = 'ServiceAccount',
  k8sRole = 'Role',
  k8sRoleMapping = 'RoleMapping',
  k8sClusterRole = 'ClusterRole',
  k8sClusterRoleMapping = 'ClusterRoleMapping',
  k8sPersistentVolume = 'PersistentVolume',
  k8sEndpoints = 'Endpoints',
  azureWebApp = 'app',
  azureFunctionApp = 'functionapp',
}

export interface ResourceTypeInfo {
  resourceType: ResourceType
  resourceVariant?: ResourceVariant
}

export enum ResourceTypeClassification {
  network,
  compute,
  storage,
  k8s,
  ai,
  other,
}

export interface ResourceTypeDetails {
  displayName: string
  pluralDisplayName: string
  sortOrder: number
  classification: ResourceTypeClassification
  displayForSelection: boolean
  displayInStatus: boolean
  supportsFailback: boolean
  supportsRealTime: boolean
  /**
   * Whether this type renders under its parent in the selection tree.  Defaults to true, since
   * `displayForSelection` only governs top-level groups.  False for sub-resources that are always
   * copied with their parent and only add noise.
   */
  displayAsChild?: boolean
}

export const resourceTypeDetails: Array<[ResourceTypeInfo, ResourceTypeDetails]> = [
  [
    { resourceType: ResourceType.acmCertificate },
    {
      displayName: 'ACM Certificate',
      pluralDisplayName: 'ACM Certificates',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayApiKey },
    {
      displayName: 'API Gateway API Key',
      pluralDisplayName: 'API Gateway API Keys',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayAccount },
    {
      displayName: 'API Gateway Account',
      pluralDisplayName: 'API Gateway Accounts',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayBasePathMapping },
    {
      displayName: 'API Gateway Base Path Mapping',
      pluralDisplayName: 'API Gateway Base Path Mappings',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  // API GW should be above Lambda, which (currently) has sortOrder 11
  [
    { resourceType: ResourceType.apiGatewayRestApi },
    {
      displayName: 'API Gateway REST API',
      pluralDisplayName: 'API Gateway REST APIs',
      sortOrder: 1.6,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayStage },
    {
      displayName: 'API Gateway Stage',
      pluralDisplayName: 'API Gateway Stages',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayUsagePlan },
    {
      displayName: 'API Gateway Usage Plan',
      pluralDisplayName: 'API Gateway Usage Plans',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayUsagePlanKey },
    {
      displayName: 'API Gateway Usage Plan Key',
      pluralDisplayName: 'API Gateway Usage Plan Keys',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayV2Api },
    {
      displayName: 'API Gateway HTTP API',
      pluralDisplayName: 'API Gateway HTTP APIs',
      sortOrder: 1.5,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayV2ApiMapping },
    {
      displayName: 'API Gateway V2 API Mapping',
      pluralDisplayName: 'API Gateway V2 API Mappings',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayV2Authorizer },
    {
      displayName: 'API Gateway V2 Authorizer',
      pluralDisplayName: 'API Gateway V2 Authorizers',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayV2DomainName },
    {
      displayName: 'API Gateway V2 Domain Name',
      pluralDisplayName: 'API Gateway V2 Domain Names',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayV2Integration },
    {
      displayName: 'API Gateway V2 Integration',
      pluralDisplayName: 'API Gateway V2 Integrations',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayV2Route },
    {
      displayName: 'API Gateway V2 Route',
      pluralDisplayName: 'API Gateway V2 Routes',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayV2Stage },
    {
      displayName: 'API Gateway V2 Stage',
      pluralDisplayName: 'API Gateway V2 Stages',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.apiGatewayV2VpcLink },
    {
      displayName: 'API Gateway V2 VPC Link',
      pluralDisplayName: 'API Gateway V2 VPC Links',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.appConfigApplication },
    {
      displayName: 'AppConfig Application',
      pluralDisplayName: 'AppConfig Applications',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.appConfigConfigurationProfile },
    {
      displayName: 'AppConfig Configuration Profile',
      pluralDisplayName: 'AppConfig Configuration Profiles',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.appConfigDeployment },
    {
      displayName: 'AppConfig Deployment',
      pluralDisplayName: 'AppConfig Deployments',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.appConfigEnvironment },
    {
      displayName: 'AppConfig Environment',
      pluralDisplayName: 'AppConfig Environments',
      sortOrder: 20,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.appConfigHostedConfigurationVersion },
    {
      displayName: 'AppConfig Hosted Configuration Version',
      pluralDisplayName: 'AppConfig Hosted Configuration Versions',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.applicationAutoScalingScalableTarget },
    {
      displayName: 'Application Auto Scaling Scalable Target',
      pluralDisplayName: 'Application Auto Scaling Scalable Targets',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.applicationAutoScalingScalingPolicy },
    {
      displayName: 'Application Auto Scaling Policy',
      pluralDisplayName: 'Application Auto Scaling Policies',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.applicationAutoScalingScheduledAction },
    {
      displayName: 'Application Auto Scaling Scheduled Action',
      pluralDisplayName: 'Application Auto Scaling Scheduled Actions',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.autoScalingGroup },
    {
      displayName: 'Autoscaling Group',
      pluralDisplayName: 'Autoscaling Groups',
      sortOrder: 15,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.autoScalingPolicy },
    {
      displayName: 'Autoscaling Policy',
      pluralDisplayName: 'Autoscaling Policies',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.autoScalingLaunchConfiguration },
    {
      displayName: 'Launch Configuration',
      pluralDisplayName: 'Launch Configurations',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.cognitoIdpIdentityProvider },
    {
      displayName: 'Cognito Identity Provider',
      pluralDisplayName: 'Cognito Identity Providers',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.cognitoIdpUserPool },
    {
      displayName: 'Cognito User Pool',
      pluralDisplayName: 'Cognito User Pools',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.cognitoIdpUserPoolClient },
    {
      displayName: 'Cognito User Pool Client',
      pluralDisplayName: 'Cognito User Pool Clients',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.cloudWatchAlarm },
    {
      displayName: 'CloudWatch Alarm',
      pluralDisplayName: 'CloudWatch Alarms',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.dynamoDbTable },
    {
      displayName: 'DynamoDB Table',
      pluralDisplayName: 'DynamoDB Tables',
      sortOrder: 5,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: true,
      supportsRealTime: true,
    },
  ],
  [
    { resourceType: ResourceType.elastiCacheCacheCluster },
    {
      displayName: 'ElastiCache Cache Cluster',
      pluralDisplayName: 'ElastiCache Cache Clusters',
      sortOrder: 14,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elastiCacheCacheParameterGroup },
    {
      displayName: 'ElastiCache Cache Parameter Group',
      pluralDisplayName: 'ElastiCache Cache Parameter Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elastiCacheCacheSubnetGroup },
    {
      displayName: 'ElastiCache Cache Subnet Group',
      pluralDisplayName: 'ElastiCache Cache Subnet Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elastiCacheReplicationGroup },
    {
      displayName: 'ElastiCache Replication Group',
      pluralDisplayName: 'ElastiCache Replication Groups',
      sortOrder: 13,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elastiCacheUser },
    {
      displayName: 'ElastiCache User',
      pluralDisplayName: 'ElastiCache Users',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elastiCacheUserGroup },
    {
      displayName: 'ElastiCache User Group',
      pluralDisplayName: 'ElastiCache User Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2Address },
    {
      displayName: 'Elastic IP',
      pluralDisplayName: 'Elastic IPs',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.firehoseDeliveryStream },
    {
      displayName: 'Data Firehose Delivery Stream',
      pluralDisplayName: 'Data Firehose Delivery Streams',
      sortOrder: 10.3,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.eventBridgeArchive },
    {
      displayName: 'EventBridge Archive',
      pluralDisplayName: 'EventBridge Archives',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.eventBridgeEventBus },
    {
      displayName: 'EventBridge Event Bus',
      pluralDisplayName: 'EventBridge Event Buses',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.eventBridgeRule },
    // Rule should be right above Lambda Function
    {
      displayName: 'EventBridge Rule',
      pluralDisplayName: 'EventBridge Rules',
      sortOrder: 10.5,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2DhcpOptions },
    {
      displayName: 'DHCP Option Set',
      pluralDisplayName: 'DHCP Option Sets',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2Image },
    {
      displayName: 'EC2 Image',
      pluralDisplayName: 'EC2 Images',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2Instance },
    {
      displayName: 'EC2 Instance',
      pluralDisplayName: 'EC2 Instances',
      sortOrder: 2,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: true,
      supportsRealTime: true,
    },
  ],
  [
    { resourceType: ResourceType.ec2InternetGateway },
    {
      displayName: 'Internet Gateway',
      pluralDisplayName: 'Internet Gateways',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2EgressOnlyInternetGateway },
    {
      displayName: 'Egress-Only Internet Gateway',
      pluralDisplayName: 'Egress-Only Internet Gateways',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2VpcPeeringConnection },
    {
      displayName: 'VPC Peering Connection',
      pluralDisplayName: 'VPC Peering Connections',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2LaunchTemplate },
    {
      displayName: 'Launch Template',
      pluralDisplayName: 'Launch Templates',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2LaunchTemplateVersion },
    {
      displayName: 'Launch Template Version',
      pluralDisplayName: 'Launch Template Versions',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2ManagedPrefixList },
    {
      displayName: 'Managed Prefix List',
      pluralDisplayName: 'Managed Prefix Lists',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2NatGateway },
    {
      displayName: 'NAT Gateway',
      pluralDisplayName: 'NAT Gateways',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2NetworkAcl },
    {
      displayName: 'Network ACL',
      pluralDisplayName: 'Network ACLs',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2RouteTable },
    {
      displayName: 'Route Table',
      pluralDisplayName: 'Route Tables',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2SecurityGroup },
    {
      displayName: 'Security Group',
      pluralDisplayName: 'Security Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2Subnet },
    {
      displayName: 'Subnet',
      pluralDisplayName: 'Subnets',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2TransitGateway },
    {
      displayName: 'Transit Gateway',
      pluralDisplayName: 'Transit Gateways',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2TransitGatewayAttachment },
    {
      displayName: 'Transit Gateway Attachment',
      pluralDisplayName: 'Transit Gateway Attachments',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2TransitGatewayRouteTable },
    {
      displayName: 'Transit Gateway Route Table',
      pluralDisplayName: 'Transit Gateway Route Tables',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2Vpc },
    {
      displayName: 'VPC',
      pluralDisplayName: 'VPCs',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2VpcEndpoint },
    {
      displayName: 'VPC Endpoint',
      pluralDisplayName: 'VPC Endpoints',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ecrRepository },
    {
      displayName: 'ECR Repository',
      pluralDisplayName: 'ECR Repositories',
      sortOrder: 10,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ecsCapacityProvider },
    {
      displayName: 'ECS Capacity Provider',
      pluralDisplayName: 'ECS Capacity Providers',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ecsCluster },
    {
      displayName: 'ECS Cluster',
      pluralDisplayName: 'ECS Clusters',
      sortOrder: 9,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ecsService },
    {
      displayName: 'ECS Service',
      pluralDisplayName: 'ECS Services',
      sortOrder: 8,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ecsTaskDefinition },
    {
      displayName: 'ECS Task Definition',
      pluralDisplayName: 'ECS Task Definitions',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ecsTaskSet },
    {
      displayName: 'ECS Task Set',
      pluralDisplayName: 'ECS Task Sets',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.efsAccessPoint },
    {
      displayName: 'EFS Access Point',
      pluralDisplayName: 'EFS Access Points',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.efsFileSystem },
    {
      displayName: 'EFS File System',
      pluralDisplayName: 'EFS File Systems',
      sortOrder: 6,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elasticBeanstalkApplication },
    {
      displayName: 'Elastic Beanstalk Application',
      pluralDisplayName: 'Elastic Beanstalk Applications',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elasticBeanstalkApplicationVersion },
    {
      displayName: 'Elastic Beanstalk Application Version',
      pluralDisplayName: 'Elastic Beanstalk Application Versions',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elasticBeanstalkConfigurationTemplate },
    {
      displayName: 'Elastic Beanstalk Configuration Template',
      pluralDisplayName: 'Elastic Beanstalk Configuration Templates',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elasticBeanstalkEnvironment },
    {
      displayName: 'Elastic Beanstalk Environment',
      pluralDisplayName: 'Elastic Beanstalk Environments',
      sortOrder: 7,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elasticBeanstalkPlatformVersion },
    {
      displayName: 'Elastic Beanstalk Platform Version',
      pluralDisplayName: 'Elastic Beanstalk Platform Versions',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elbClassicLoadBalancer },
    {
      displayName: 'ELB Classic Load Balancer',
      pluralDisplayName: 'ELB Classic Load Balancers',
      sortOrder: 1,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elbLoadBalancer },
    {
      displayName: 'ELB Load Balancer',
      pluralDisplayName: 'ELB Load Balancers',
      sortOrder: 0,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.elbTargetGroup },
    {
      displayName: 'ELB Target Group',
      pluralDisplayName: 'ELB Target Groups',
      sortOrder: 0.5,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.fsxFileSystem },
    {
      displayName: 'FSx File System',
      pluralDisplayName: 'FSx File Systems',
      sortOrder: 6,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.fsxStorageVirtualMachine },
    {
      displayName: 'FSx Storage Virtual Machine',
      pluralDisplayName: 'FSx Storage Virtual Machines',
      sortOrder: 7,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.fsxVolume },
    {
      displayName: 'FSx Storage Volume',
      pluralDisplayName: 'FSx Storage Volumes',
      sortOrder: 8,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.iamInstanceProfile },
    {
      displayName: 'Instance Profile',
      pluralDisplayName: 'Instance Profiles',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.iamManagedPolicy },
    {
      displayName: 'IAM Policy',
      pluralDisplayName: 'IAM Policies',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.iamOidcProvider },
    {
      displayName: 'IAM OIDC Provider',
      pluralDisplayName: 'IAM OIDC Providers',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.iamRole },
    {
      displayName: 'IAM Role',
      pluralDisplayName: 'IAM Roles',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.iamRoot },
    {
      displayName: 'IAM Account Root User',
      pluralDisplayName: 'IAM Account Root Users',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.lambdaFunction },
    {
      displayName: 'Lambda Function',
      pluralDisplayName: 'Lambda Functions',
      sortOrder: 11,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.lambdaFunctionAlias },
    {
      displayName: 'Lambda Function Alias',
      pluralDisplayName: 'Lambda Function Aliases',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.lambdaFunctionVersion },
    {
      displayName: 'Lambda Function Version',
      pluralDisplayName: 'Lambda Function Versions',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.lambdaLayerVersion },
    {
      displayName: 'Lambda Layer Version',
      pluralDisplayName: 'Lambda Layer Versions',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.mqBroker },
    {
      displayName: 'MQ Broker',
      pluralDisplayName: 'MQ Brokers',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.mqConfigurationRevision },
    {
      displayName: 'MQ Broker Configuration Revision',
      pluralDisplayName: 'MQ Broker Configuration Revisions',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ramResourceShare },
    {
      displayName: 'RAM Resource Share',
      pluralDisplayName: 'RAM Resource Shares',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.rdsDbCluster, resourceVariant: ResourceVariant.docDbCluster },
    {
      displayName: 'DocumentDB Cluster',
      pluralDisplayName: 'DocumentDB Clusters',
      sortOrder: 3,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: true,
      supportsRealTime: true,
    },
  ],
  [
    { resourceType: ResourceType.rdsDbCluster },
    {
      displayName: 'RDS DB Cluster',
      pluralDisplayName: 'RDS DB Clusters',
      sortOrder: 3,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: true,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.rdsDbClusterParameterGroup },
    {
      displayName: 'RDS DB Cluster Parameter Group',
      pluralDisplayName: 'RDS DB Cluster Parameter Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.rdsDbInstance, resourceVariant: ResourceVariant.docDbInstance },
    {
      displayName: 'DocumentDB Instance',
      pluralDisplayName: 'DocumentDB Instances',
      sortOrder: 4,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.rdsDbInstance },
    {
      displayName: 'RDS DB Instance',
      pluralDisplayName: 'RDS DB Instances',
      sortOrder: 4,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: true,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.rdsDbParameterGroup },
    {
      displayName: 'RDS DB Parameter Group',
      pluralDisplayName: 'RDS DB Parameter Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.rdsDbSubnetGroup },
    {
      displayName: 'RDS DB Subnet Group',
      pluralDisplayName: 'RDS DB Subnet Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.rdsOptionGroup },
    {
      displayName: 'RDS Option Group',
      pluralDisplayName: 'RDS Option Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.rdsDbProxy },
    {
      displayName: 'RDS DB Proxy',
      pluralDisplayName: 'RDS DB Proxies',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.rdsDbProxyTargetGroup },
    {
      displayName: 'RDS DB Proxy Target Group',
      pluralDisplayName: 'RDS DB Proxy Target Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: true,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.rdsDbProxyEndpoint },
    {
      displayName: 'RDS DB Proxy Endpoint',
      pluralDisplayName: 'RDS DB Proxy Endpoints',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.redshiftCluster },
    {
      displayName: 'Redshift Cluster',
      pluralDisplayName: 'Redshift Clusters',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.redshiftClusterParameterGroup },
    {
      displayName: 'Redshift Cluster Parameter Group',
      pluralDisplayName: 'Redshift Cluster Parameter Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.redshiftClusterSubnetGroup },
    {
      displayName: 'Redshift Cluster Subnet Group',
      pluralDisplayName: 'Redshift Cluster Subnet Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.redshiftServerlessNamespace },
    {
      displayName: 'Redshift Serverless Namespace',
      pluralDisplayName: 'Redshift Serverless Namespaces',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.redshiftServerlessWorkgroup },
    {
      displayName: 'Redshift Serverless Workgroup',
      pluralDisplayName: 'Redshift Serverless Workgroups',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.networkFirewallFirewall },
    {
      displayName: 'Network Firewall',
      pluralDisplayName: 'Network Firewalls',
      sortOrder: 25,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.networkFirewallPolicy },
    {
      displayName: 'Network Firewall Policy',
      pluralDisplayName: 'Network Firewall Policies',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.networkFirewallRuleGroup },
    {
      displayName: 'Network Firewall Rule Group',
      pluralDisplayName: 'Network Firewall Rule Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.networkFirewallTlsInspectionConfiguration },
    {
      displayName: 'Network Firewall TLS Inspection Configuration',
      pluralDisplayName: 'Network Firewall TLS Inspection Configurations',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.networkFirewallVpcEndpointAssociation },
    {
      displayName: 'Network Firewall VPC Endpoint Association',
      pluralDisplayName: 'Network Firewall VPC Endpoint Associations',
      sortOrder: 99,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.resourceGroupsGroup },
    {
      displayName: 'Resource Group',
      pluralDisplayName: 'Resource Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.openSearchDomain },
    {
      displayName: 'OpenSearch Domain',
      pluralDisplayName: 'OpenSearch Domains',
      sortOrder: 5.5,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.osisPipeline },
    {
      displayName: 'OpenSearch Ingestion Pipeline',
      pluralDisplayName: 'OpenSearch Ingestion Pipelines',
      sortOrder: 5.6,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.openSearchServerlessCollectionGroup },
    {
      displayName: 'OpenSearch Serverless Collection Group',
      pluralDisplayName: 'OpenSearch Serverless Collection Groups',
      sortOrder: 50,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.openSearchServerlessCollection },
    {
      displayName: 'OpenSearch Serverless Collection',
      pluralDisplayName: 'OpenSearch Serverless Collections',
      sortOrder: 51,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.openSearchServerlessDataAccessPolicy },
    {
      displayName: 'OpenSearch Serverless Access Policy',
      pluralDisplayName: 'OpenSearch Serverless Access Policies',
      sortOrder: 52,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.openSearchServerlessLifecyclePolicy },
    {
      displayName: 'OpenSearch Serverless Lifecycle Policy',
      pluralDisplayName: 'OpenSearch Serverless Lifecycle Policies',
      sortOrder: 52,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.openSearchServerlessSecurityPolicy },
    {
      displayName: 'OpenSearch Serverless Security Policy',
      pluralDisplayName: 'OpenSearch Serverless Security Policies',
      sortOrder: 52,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.openSearchServerlessVpcEndpoint },
    {
      displayName: 'OpenSearch Serverless VPC Endpoint',
      pluralDisplayName: 'OpenSearch Serverless VPC Endpoints',
      sortOrder: 52,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.s3Bucket },
    {
      displayName: 'S3 Bucket',
      pluralDisplayName: 'S3 Buckets',
      sortOrder: 5,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: true,
    },
  ],
  [
    { resourceType: ResourceType.schedulerSchedule },
    {
      displayName: 'EventBridge Schedule',
      pluralDisplayName: 'EventBridge Schedules',
      sortOrder: 10.5,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.schedulerScheduleGroup },
    {
      displayName: 'EventBridge Schedule Group',
      pluralDisplayName: 'EventBridge Schedule Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.serviceDiscoveryNamespace },
    {
      displayName: 'Cloud Map Namespace',
      pluralDisplayName: 'Cloud Map Namespaces',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.serviceDiscoveryService },
    {
      displayName: 'Cloud Map Service',
      pluralDisplayName: 'Cloud Map Services',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.sfnStateMachine },
    {
      displayName: 'Step Functions State Machine',
      pluralDisplayName: 'Step Functions State Machines',
      sortOrder: 20,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.sfnStateMachineVersion },
    {
      displayName: 'Step Functions State Machine Version',
      pluralDisplayName: 'Step Functions State Machine Versions',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.sfnStateMachineAlias },
    {
      displayName: 'Step Functions State Machine Alias',
      pluralDisplayName: 'Step Functions State Machine Aliases',
      sortOrder: 20,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.snsTopic },
    {
      displayName: 'SNS Topic',
      pluralDisplayName: 'SNS Topics',
      sortOrder: 16,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.spotElastigroup },
    {
      displayName: 'Spot by NetApp Elastigroup',
      pluralDisplayName: 'Spot by NetApp Elastigroups',
      sortOrder: 15.5,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.sqsQueue },
    {
      displayName: 'SQS Queue',
      pluralDisplayName: 'SQS Queues',
      sortOrder: 17,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.route53ProfilesProfile },
    {
      displayName: 'Route 53 Profiles Profile',
      pluralDisplayName: 'Route 53 Profiles Profiles',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.route53ResolverConfig },
    {
      displayName: 'Route 53 Resolver Configuration',
      pluralDisplayName: 'Route 53 Resolver Configurations',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.route53ResolverFirewallDomainList },
    {
      displayName: 'Route 53 Resolver Firewall Domain List',
      pluralDisplayName: 'Route 53 Resolver Firewall Domain Lists',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.route53ResolverEndpoint },
    {
      displayName: 'Route 53 Resolver Endpoint',
      pluralDisplayName: 'Route 53 Resolver Endpoints',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.route53ResolverFirewallRuleGroup },
    {
      displayName: 'Route 53 Resolver Firewall Rule Group',
      pluralDisplayName: 'Route 53 Resolver Firewall Rule Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.route53ResolverRule },
    {
      displayName: 'Route 53 Resolver Rule',
      pluralDisplayName: 'Route 53 Resolver Rules',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.route53PrivateHostedZone },
    {
      displayName: 'Route 53 Private Hosted Zone',
      pluralDisplayName: 'Route 53 Private Hosted Zones',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.secretsManagerSecret },
    {
      displayName: 'Secrets Manager Secret',
      pluralDisplayName: 'Secrets Manager Secrets',
      sortOrder: 12,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.wafV2IpSet },
    {
      displayName: 'WAFv2 IP Set',
      pluralDisplayName: 'WAFv2 IP Sets',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.wafV2RegexPatternSet },
    {
      displayName: 'WAFv2 Regex Pattern Set',
      pluralDisplayName: 'WAFv2 Regex Pattern Sets',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.wafV2RuleGroup },
    {
      displayName: 'WAFv2 Rule Group',
      pluralDisplayName: 'WAFv2 Rule Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.wafV2WebAcl },
    {
      displayName: 'WAFv2 Web ACL',
      pluralDisplayName: 'WAFv2 Web ACLs',
      sortOrder: 18,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ssmParameter },
    {
      displayName: 'SSM Parameter',
      pluralDisplayName: 'SSM Parameters',
      sortOrder: 12.5,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.eksCluster },
    {
      displayName: 'EKS Cluster',
      pluralDisplayName: 'EKS Clusters',
      sortOrder: 9,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.eksAddon },
    {
      displayName: 'EKS Addon',
      pluralDisplayName: 'EKS Addons',
      sortOrder: 9.1,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.eksNodegroup },
    {
      displayName: 'EKS Nodegroup',
      pluralDisplayName: 'EKS Nodegroups',
      sortOrder: 9.2,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.eksFargateProfile },
    {
      displayName: 'EKS Fargate Profile',
      pluralDisplayName: 'EKS Fargate Profiles',
      sortOrder: 9.3,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ec2EbsVolume },
    {
      displayName: 'EBS Volume',
      pluralDisplayName: 'EBS Volumes',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.kmsAlias },
    {
      displayName: 'KMS Alias',
      pluralDisplayName: 'KMS Aliases',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.kmsKey },
    {
      displayName: 'KMS Key',
      pluralDisplayName: 'KMS Keys',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.transferServer },
    {
      displayName: 'Transfer Family Server',
      pluralDisplayName: 'Transfer Family Servers',
      sortOrder: 4,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.transferUser },
    {
      displayName: 'Transfer Family User',
      pluralDisplayName: 'Transfer Family Users',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.transferWorkflow },
    {
      displayName: 'Transfer Family Workflow',
      pluralDisplayName: 'Transfer Family Workflows',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.transferHostKey },
    {
      displayName: 'Transfer Family Host Key',
      pluralDisplayName: 'Transfer Family Host Keys',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.ecrPullThroughCacheRule },
    {
      displayName: 'ECR Pull Through Cache Rule',
      pluralDisplayName: 'ECR Pull Through Cache Rules',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.glueJob },
    {
      displayName: 'Glue Job',
      pluralDisplayName: 'Glue Jobs',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.glueTrigger },
    {
      displayName: 'Glue Trigger',
      pluralDisplayName: 'Glue Triggers',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.organization },
    {
      displayName: 'Organization',
      pluralDisplayName: 'Organizations',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],

  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sNamespace },
    {
      displayName: 'Kubernetes Namespace',
      pluralDisplayName: 'Kubernetes Namespaces',
      sortOrder: 10,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sIngress },
    {
      displayName: 'Kubernetes Ingress',
      pluralDisplayName: 'Kubernetes Ingresses',
      sortOrder: 11,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sService },
    {
      displayName: 'Kubernetes Service',
      pluralDisplayName: 'Kubernetes Services',
      sortOrder: 12,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sDeployment },
    {
      displayName: 'Kubernetes Deployment',
      pluralDisplayName: 'Kubernetes Deployments',
      sortOrder: 13,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sRollout },
    {
      displayName: 'Kubernetes Argo Rollout',
      pluralDisplayName: 'Kubernetes Argo Rollouts',
      sortOrder: 14,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sDaemonSet },
    {
      displayName: 'Kubernetes Daemon Set',
      pluralDisplayName: 'Kubernetes Daemon Sets',
      sortOrder: 15,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sStatefulSet },
    {
      displayName: 'Kubernetes Stateful Set',
      pluralDisplayName: 'Kubernetes Stateful Sets',
      sortOrder: 16,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sJob },
    {
      displayName: 'Kubernetes Job',
      pluralDisplayName: 'Kubernetes Jobs',
      sortOrder: 17,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sCronJob },
    {
      displayName: 'Kubernetes Cron Job',
      pluralDisplayName: 'Kubernetes Cron Jobs',
      sortOrder: 18,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sPersistentVolume },
    {
      displayName: 'Kubernetes Persistent Volume',
      pluralDisplayName: 'Kubernetes Persistent Volumes',
      sortOrder: 19,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sConfigMap },
    {
      displayName: 'Kubernetes Config Map',
      pluralDisplayName: 'Kubernetes Config Maps',
      sortOrder: 20,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sSecret },
    {
      displayName: 'Kubernetes Secret',
      pluralDisplayName: 'Kubernetes Secrets',
      sortOrder: 21,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sServiceAccount },
    {
      displayName: 'Kubernetes Service Account',
      pluralDisplayName: 'Kubernetes Service Accounts',
      sortOrder: 22,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sRole },
    {
      displayName: 'Kubernetes Role',
      pluralDisplayName: 'Kubernetes Roles',
      sortOrder: 23,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.k8sResource, resourceVariant: ResourceVariant.k8sClusterRole },
    {
      displayName: 'Kubernetes Cluster Role',
      pluralDisplayName: 'Kubernetes Cluster Roles',
      sortOrder: 24,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.kafkaConfiguration },
    {
      displayName: 'MSK Configuration',
      pluralDisplayName: 'MSK Configurations',
      sortOrder: 17.5,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.kafkaConfigurationRevision },
    {
      displayName: 'MSK Configuration Revision',
      pluralDisplayName: 'MSK Configuration Revisions',
      sortOrder: 17.5,
      classification: ResourceTypeClassification.other,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.kafkaCluster },
    {
      displayName: 'MSK Cluster',
      pluralDisplayName: 'MSK Clusters',
      sortOrder: 17.6,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreWorkloadIdentity },
    {
      displayName: 'Bedrock AgentCore Workload Identity',
      pluralDisplayName: 'Bedrock AgentCore Workload Identities',
      sortOrder: 65,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreMemory },
    {
      displayName: 'Bedrock AgentCore Memory',
      pluralDisplayName: 'Bedrock AgentCore Memories',
      sortOrder: 25,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreApiKeyCredentialProvider },
    {
      displayName: 'Bedrock AgentCore API Key Credential Provider',
      pluralDisplayName: 'Bedrock AgentCore API Key Credential Providers',
      sortOrder: 40,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreOAuth2CredentialProvider },
    {
      displayName: 'Bedrock AgentCore OAuth2 Credential Provider',
      pluralDisplayName: 'Bedrock AgentCore OAuth2 Credential Providers',
      sortOrder: 45,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreRuntime },
    {
      displayName: 'Bedrock AgentCore Runtime',
      pluralDisplayName: 'Bedrock AgentCore Runtimes',
      sortOrder: 15,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreRuntimeEndpoint },
    {
      displayName: 'Bedrock AgentCore Runtime Endpoint',
      pluralDisplayName: 'Bedrock AgentCore Runtime Endpoints',
      sortOrder: 20,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreGateway },
    {
      displayName: 'Bedrock AgentCore Gateway',
      pluralDisplayName: 'Bedrock AgentCore Gateways',
      sortOrder: 5,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreGatewayTarget },
    {
      displayName: 'Bedrock AgentCore Gateway Target',
      pluralDisplayName: 'Bedrock AgentCore Gateway Targets',
      sortOrder: 10,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcorePolicy },
    {
      displayName: 'Bedrock AgentCore Policy',
      pluralDisplayName: 'Bedrock AgentCore Policies',
      sortOrder: 30,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcorePolicyEngine },
    {
      displayName: 'Bedrock AgentCore Policy Engine',
      pluralDisplayName: 'Bedrock AgentCore Policy Engines',
      sortOrder: 35,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreBrowser },
    {
      displayName: 'Bedrock AgentCore Browser',
      pluralDisplayName: 'Bedrock AgentCore Browsers',
      sortOrder: 50,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreCodeInterpreter },
    {
      displayName: 'Bedrock AgentCore Code Interpreter',
      pluralDisplayName: 'Bedrock AgentCore Code Interpreters',
      sortOrder: 55,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreEvaluator },
    {
      displayName: 'Bedrock AgentCore Evaluator',
      pluralDisplayName: 'Bedrock AgentCore Evaluators',
      sortOrder: 70,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockAgentcoreOnlineEvaluationConfig },
    {
      displayName: 'Bedrock AgentCore Online Evaluation Config',
      pluralDisplayName: 'Bedrock AgentCore Online Evaluation Configs',
      sortOrder: 60,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockGuardrail },
    {
      displayName: 'Bedrock Guardrail',
      pluralDisplayName: 'Bedrock Guardrails',
      sortOrder: 75,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockKnowledgeBase },
    {
      displayName: 'Bedrock Knowledge Base',
      pluralDisplayName: 'Bedrock Knowledge Bases',
      sortOrder: 80,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.bedrockKnowledgeBaseDataSource },
    {
      displayName: 'Bedrock Knowledge Base Data Source',
      pluralDisplayName: 'Bedrock Knowledge Base Data Sources',
      sortOrder: 85,
      classification: ResourceTypeClassification.ai,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureStorageAccount },
    {
      displayName: 'Storage Account',
      pluralDisplayName: 'Storage Accounts',
      sortOrder: 10,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureBlobContainer },
    {
      displayName: 'Blob Container',
      pluralDisplayName: 'Blob Containers',
      sortOrder: 11,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureContainerApp },
    {
      displayName: 'Container App',
      pluralDisplayName: 'Container Apps',
      sortOrder: 12,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureContainerAppAuthConfig },
    {
      displayName: 'Container App Auth Config',
      pluralDisplayName: 'Container App Auth Configs',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureContainerAppJob },
    {
      displayName: 'Container App Job',
      pluralDisplayName: 'Container App Jobs',
      sortOrder: 13,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureContainerAppManagedEnvironment },
    {
      displayName: 'Container App Managed Environment',
      pluralDisplayName: 'Container App Managed Environments',
      sortOrder: 13,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureContainerAppManagedEnvironmentCertificate },
    {
      displayName: 'Container App Managed Environment Certificate',
      pluralDisplayName: 'Container App Managed Environment Certificates',
      sortOrder: 14,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureContainerAppManagedEnvironmentManagedCertificate },
    {
      displayName: 'Container App Managed Environment Managed Certificate',
      pluralDisplayName: 'Container App Managed Environment Managed Certificates',
      sortOrder: 15,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureQueue },
    {
      displayName: 'Queue',
      pluralDisplayName: 'Queues',
      sortOrder: 12,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureResourceGroup },
    {
      displayName: 'Resource Group',
      pluralDisplayName: 'Resource Groups',
      sortOrder: 1,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureNetworkSecurityGroup },
    {
      displayName: 'Network Security Group',
      pluralDisplayName: 'Network Security Groups',
      sortOrder: 10,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureApplicationSecurityGroup },
    {
      displayName: 'Application Security Group',
      pluralDisplayName: 'Application Security Groups',
      sortOrder: 10,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureNetworkInterface },
    {
      displayName: 'Network Interface',
      pluralDisplayName: 'Network Interfaces',
      sortOrder: 20,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureSubnet },
    {
      displayName: 'Subnet',
      pluralDisplayName: 'Subnets',
      sortOrder: 4,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureVirtualNetwork },
    {
      displayName: 'Virtual Network',
      pluralDisplayName: 'Virtual Networks',
      sortOrder: 4,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureVirtualNetworkPeering },
    {
      displayName: 'Virtual Network Peering',
      pluralDisplayName: 'Virtual Network Peerings',
      sortOrder: 4,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azurePublicIp },
    {
      displayName: 'Public IP Address',
      pluralDisplayName: 'Public IP Addresses',
      sortOrder: 5,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureNatGateway },
    {
      displayName: 'NAT Gateway',
      pluralDisplayName: 'NAT Gateways',
      sortOrder: 6,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureNetAppAccount },
    {
      displayName: 'Azure NetApp Files Account',
      pluralDisplayName: 'Azure NetApp Files Accounts',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureNetAppCapacityPool },
    {
      displayName: 'Azure NetApp Files Capacity Pool',
      pluralDisplayName: 'Azure NetApp Files Capacity Pools',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureNetAppVolume },
    {
      displayName: 'Azure NetApp Files Volume',
      pluralDisplayName: 'Azure NetApp Files Volumes',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureRouteTable },
    {
      displayName: 'Route Table',
      pluralDisplayName: 'Route Tables',
      sortOrder: 7,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureVirtualMachine },
    {
      displayName: 'Virtual Machine',
      pluralDisplayName: 'Virtual Machines',
      sortOrder: 4,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureImage },
    {
      displayName: 'Image',
      pluralDisplayName: 'Images',
      sortOrder: 10,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureDisk },
    {
      displayName: 'Disk',
      pluralDisplayName: 'Disks',
      sortOrder: 20,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureDiskEncryptionSet },
    {
      displayName: 'Disk Encryption Set',
      pluralDisplayName: 'Disk Encryption Sets',
      sortOrder: 21,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureSubscription },
    {
      displayName: 'Subscription',
      pluralDisplayName: 'Subscriptions',
      sortOrder: 99,
      classification: ResourceTypeClassification.compute,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureRoleDefinition },
    {
      displayName: 'Role Definition',
      pluralDisplayName: 'Role Definitions',
      sortOrder: 20,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureManagedIdentity },
    {
      displayName: 'Managed Identity',
      pluralDisplayName: 'Managed Identities',
      sortOrder: 21,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureFederatedIdentityCredential },
    {
      displayName: 'Federated Identity Credential',
      pluralDisplayName: 'Federated Identity Credentials',
      sortOrder: 21,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureRoleAssignment },
    {
      displayName: 'Role Assignment',
      pluralDisplayName: 'Role Assignments',
      sortOrder: 22,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureKeyVault },
    {
      displayName: 'Key Vault',
      pluralDisplayName: 'Key Vaults',
      sortOrder: 10,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureKeyVaultKey },
    {
      displayName: 'Key Vault Key',
      pluralDisplayName: 'Key Vault Keys',
      sortOrder: 11,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureKeyVaultSecret },
    {
      displayName: 'Key Vault Secret',
      pluralDisplayName: 'Key Vault Secrets',
      sortOrder: 12,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureKeyVaultCertificate },
    {
      displayName: 'Key Vault Certificate',
      pluralDisplayName: 'Key Vault Certificates',
      sortOrder: 13,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureResourceProvider },
    {
      displayName: 'Resource Provider',
      pluralDisplayName: 'Resource Providers',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureApplicationGateway },
    {
      displayName: 'Application Gateway',
      pluralDisplayName: 'Application Gateways',
      sortOrder: 2,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureLoadBalancer },
    {
      displayName: 'Load Balancer',
      pluralDisplayName: 'Load Balancers',
      sortOrder: 3,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azurePostgresFlexibleServer },
    {
      displayName: 'PostgreSQL Flexible Server',
      pluralDisplayName: 'PostgreSQL Flexible Servers',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azurePostgresFlexibleServerConfiguration },
    {
      displayName: 'PostgreSQL Server Configuration',
      pluralDisplayName: 'PostgreSQL Server Configurations',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
      displayAsChild: false,
    },
  ],

  [
    { resourceType: ResourceType.azurePostgresFlexibleServerFirewallRule },
    {
      displayName: 'PostgreSQL Firewall Rule',
      pluralDisplayName: 'PostgreSQL Firewall Rules',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
      displayAsChild: false,
    },
  ],
  [
    { resourceType: ResourceType.azurePostgresFlexibleServerAdministrator },
    {
      displayName: 'PostgreSQL Administrator',
      pluralDisplayName: 'PostgreSQL Administrators',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
      displayAsChild: false,
    },
  ],
  [
    { resourceType: ResourceType.azurePostgresFlexibleServerDatabase },
    {
      displayName: 'PostgreSQL Database',
      pluralDisplayName: 'PostgreSQL Databases',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureSqlVirtualMachine },
    {
      displayName: 'SQL Virtual Machine',
      pluralDisplayName: 'SQL Virtual Machines',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureSqlServer },
    {
      displayName: 'SQL Logical Server',
      pluralDisplayName: 'SQL Logical Servers',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureSqlServerConnectionPolicies },
    {
      displayName: 'SQL Server Connection Policy',
      pluralDisplayName: 'SQL Server Connection Policies',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
      displayAsChild: false,
    },
  ],
  [
    { resourceType: ResourceType.azureSqlServerDnsAliases },
    {
      displayName: 'SQL Server DNS Alias',
      pluralDisplayName: 'SQL Server DNS Aliases',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
      displayAsChild: false,
    },
  ],
  [
    { resourceType: ResourceType.azureSqlServerFirewallRule },
    {
      displayName: 'SQL Server Firewall Rule',
      pluralDisplayName: 'SQL Server Firewall Rules',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
      displayAsChild: false,
    },
  ],
  [
    { resourceType: ResourceType.azureSqlServerOutboundFirewallRule },
    {
      displayName: 'SQL Server Outbound Firewall Rule',
      pluralDisplayName: 'SQL Server Outbound Firewall Rules',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
      displayAsChild: false,
    },
  ],
  [
    { resourceType: ResourceType.azureSqlServerVirtualNetworkRule },
    {
      displayName: 'SQL Server Virtual Network Rule',
      pluralDisplayName: 'SQL Server Virtual Network Rules',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
      displayAsChild: false,
    },
  ],
  [
    { resourceType: ResourceType.azureSqlDatabase },
    {
      displayName: 'SQL Database',
      pluralDisplayName: 'SQL Databases',
      sortOrder: 99,
      classification: ResourceTypeClassification.storage,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureContainerGroup },
    {
      displayName: 'Container Instance',
      pluralDisplayName: 'Container Instances',
      sortOrder: 50,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureContainerRegistry },
    {
      displayName: 'Container Registry',
      pluralDisplayName: 'Container Registries',
      sortOrder: 50,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureContainerRepository },
    {
      displayName: 'Container Repository',
      pluralDisplayName: 'Container Repositories',
      sortOrder: 51,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureVirtualMachineScaleSet },
    {
      displayName: 'Virtual Machine Scale Set',
      pluralDisplayName: 'Virtual Machine Scale Sets',
      sortOrder: 4,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azurePrivateDnsZone },
    {
      displayName: 'Private DNS Zone',
      pluralDisplayName: 'Private DNS Zones',
      sortOrder: 10,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azurePrivateDnsZoneVirtualNetworkLink },
    {
      displayName: 'Private DNS Zone Virtual Network Link',
      pluralDisplayName: 'Private DNS Zone Virtual Network Links',
      sortOrder: 10,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
      displayAsChild: false,
    },
  ],
  [
    { resourceType: ResourceType.azurePrivateDnsZoneRecordSet },
    {
      displayName: 'DNS Record Set',
      pluralDisplayName: 'DNS Record Sets',
      sortOrder: 10,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
      displayAsChild: false,
    },
  ],
  [
    { resourceType: ResourceType.azureBastionHost },
    {
      displayName: 'Bastion Host',
      pluralDisplayName: 'Bastion Hosts',
      sortOrder: 10,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azurePrivateEndpoint },
    {
      displayName: 'Private Endpoint',
      pluralDisplayName: 'Private Endpoints',
      sortOrder: 10,
      classification: ResourceTypeClassification.network,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azurePrivateDnsZoneGroups },
    {
      displayName: 'Private DNS Zone Group',
      pluralDisplayName: 'Private DNS Zone Groups',
      sortOrder: 10,
      classification: ResourceTypeClassification.network,
      displayForSelection: false,
      displayInStatus: false,
      supportsFailback: false,
      supportsRealTime: false,
      displayAsChild: false,
    },
  ],
  [
    { resourceType: ResourceType.azureAppServiceEnvironment },
    {
      displayName: 'App Service Environment',
      pluralDisplayName: 'App Service Environments',
      sortOrder: 20,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureAppServicePlan },
    {
      displayName: 'App Service Plan',
      pluralDisplayName: 'App Service Plans',
      sortOrder: 20,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureWebApp, resourceVariant: ResourceVariant.azureWebApp },
    {
      displayName: 'Web App',
      pluralDisplayName: 'Web Apps',
      sortOrder: 20,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureWebApp, resourceVariant: ResourceVariant.azureFunctionApp },
    {
      displayName: 'Function App',
      pluralDisplayName: 'Function Apps',
      sortOrder: 21,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureWebAppCertificate },
    {
      displayName: 'Web App Service Certificate',
      pluralDisplayName: 'Web App Service Certificates',
      sortOrder: 22,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureWebAppHostNameBinding },
    {
      displayName: 'Web App Host Name Binding',
      pluralDisplayName: 'Web App Host Name Bindings',
      sortOrder: 21,
      classification: ResourceTypeClassification.compute,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureAksCluster },
    {
      displayName: 'AKS Cluster',
      pluralDisplayName: 'AKS Clusters',
      sortOrder: 1,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureAksNodePool },
    {
      displayName: 'AKS Node Pool',
      pluralDisplayName: 'AKS Node Pools',
      sortOrder: 2,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.azureLogAnalyticsWorkspace },
    {
      displayName: 'Log Analytics Workspace',
      pluralDisplayName: 'Log Analytics Workspaces',
      sortOrder: 2,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.dmsCertificate },
    {
      displayName: 'DMS Certificate',
      pluralDisplayName: 'DMS Certificates',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.dmsEndpoint },
    {
      displayName: 'DMS Endpoint',
      pluralDisplayName: 'DMS Endpoints',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.dmsReplicationInstance },
    {
      displayName: 'DMS Replication Instance',
      pluralDisplayName: 'DMS Replication Instances',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.dmsReplicationSubnetGroup },
    {
      displayName: 'DMS Replication Subnet Group',
      pluralDisplayName: 'DMS Replication Subnet Groups',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
  [
    { resourceType: ResourceType.dmsReplicationTask },
    {
      displayName: 'DMS Replication Task',
      pluralDisplayName: 'DMS Replication Tasks',
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    },
  ],
]

function rtiKey(rti: ResourceTypeInfo) {
  return rti.resourceType + '|' + (rti.resourceVariant ? rti.resourceVariant : '')
}

const resourceTypeDetailsByKey: Map<string, ResourceTypeDetails> = new Map(
  resourceTypeDetails.map((rtd) => {
    return [rtiKey(rtd[0]), rtd[1]]
  })
)

export function getResourceTypeDetails(rti: ResourceTypeInfo): ResourceTypeDetails {
  // Lookup resource type details from the above array.
  // We use double = on the variant on purpose so that null and undefined will be equal.
  // tslint:disable-next-line:triple-equals
  const key = rtiKey(rti)
  const rtd = resourceTypeDetailsByKey.get(key)

  if (rtd) {
    return rtd
  } else if (rti.resourceType == ResourceType.k8sResource && rti.resourceVariant) {
    const dynamicRtd = {
      displayName: `Kubernetes ${rti.resourceVariant}`,
      pluralDisplayName: `Kubernetes ${rti.resourceVariant}s`, // Since this is a fallback do we need to do better?
      sortOrder: 99,
      classification: ResourceTypeClassification.k8s,
      displayForSelection: false,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    }
    resourceTypeDetailsByKey.set(key, dynamicRtd)
    return dynamicRtd
  } else {
    const dynamicRtd = {
      displayName: rti.resourceType,
      pluralDisplayName: `${rti.resourceType}s`, // Since this is a fallback do we need to do better?
      sortOrder: 99,
      classification: ResourceTypeClassification.other,
      displayForSelection: true,
      displayInStatus: true,
      supportsFailback: false,
      supportsRealTime: false,
    }
    resourceTypeDetailsByKey.set(key, dynamicRtd)
    return dynamicRtd
  }
}

export function computeResourceTypePriority(typeInfo: ResourceTypeInfo) {
  return getResourceTypeDetails(typeInfo).sortOrder
}

export function getResourceTypeClassification(typeInfo: ResourceTypeInfo) {
  return getResourceTypeDetails(typeInfo).classification
}

export function resourceTypeSupportsFailback(typeInfo: ResourceTypeInfo) {
  return getResourceTypeDetails(typeInfo).supportsFailback
}
